import React from 'react';
import './StaticPages.css';

export function Privacy() {
  return (
    <div className="static-page">
      <div className="page-header">
        <h1>Privacy Policy</h1>
        <p>How we protect and use your information</p>
      </div>
      <div className="container static-content">
        <div className="legal-content">
          <p className="legal-updated">Last updated: January 2024</p>

          <section className="legal-section">
            <h2>1. Information We Collect</h2>
            <p>When you register or use our services, we may collect:</p>
            <ul>
              <li>Name, Age, Date of Birth, Gender</li>
              <li>Phone Number and Address / Location</li>
              <li>Religion / Community and Family details</li>
              <li>Education and Occupation details</li>
              <li>Profile photographs and Birth Horoscope</li>
              <li>Payment Transaction ID (UPI)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Your Information</h2>
            <p>Your information is used to:</p>
            <ul>
              <li>Create and manage your matrimony profile</li>
              <li>Help find suitable matches based on horoscope compatibility</li>
              <li>Allow communication between members via contact request system</li>
              <li>Verify profiles and maintain platform safety</li>
              <li>Improve our services and platform experience</li>
              <li>Provide customer support</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Profile Visibility</h2>
            <p>Your profile information may be visible to other registered and approved members for matchmaking purposes. Sensitive information such as contact numbers are protected through our <strong>Contact Request System</strong> — phone numbers are only revealed after you explicitly approve a contact request.</p>
          </section>

          <section className="legal-section">
            <h2>4. Data Security</h2>
            <p>We take reasonable measures to protect your personal data including password encryption, secure server storage, and admin-verified access. However, no online platform can guarantee complete security of data transmitted over the internet.</p>
          </section>

          <section className="legal-section">
            <h2>5. Cookies Policy</h2>
            <p>Our website uses cookies to improve user experience, remember login sessions, and analyze website traffic. By using the website, you consent to the use of cookies.</p>
          </section>

          <section className="legal-section">
            <h2>6. Contact Information</h2>
            <p>For questions regarding this policy, contact:</p>
            <p><strong>Suvaran Maran Matrimony</strong><br />
            Email: support@suvaranmaranmatrimony.msdiscoveriescom<br />
            Phone: +91 9842724724</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <div className="static-page">
      <div className="page-header">
        <h1>Terms & Conditions</h1>
        <p>Please read these terms carefully before using our platform</p>
      </div>
      <div className="container static-content">
        <div className="legal-content">
          <p className="legal-updated">Last updated: January 2024</p>

          <section className="legal-section">
            <h2>1. Eligibility</h2>
            <ul>
              <li>Users must be <strong>18 years or older</strong> to register.</li>
              <li>The platform is intended only for individuals seeking marriage alliances.</li>
              <li>Only one profile is allowed per phone number.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. Account Responsibility</h2>
            <p>Users are responsible for:</p>
            <ul>
              <li>Providing accurate and truthful information</li>
              <li>Maintaining confidentiality of login credentials</li>
              <li>Updating profile information when necessary</li>
              <li>All activities that occur under their account</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Acceptable Use</h2>
            <p>Users must <strong>NOT</strong>:</p>
            <ul>
              <li>Upload false or misleading information</li>
              <li>Harass, threaten, or abuse other members</li>
              <li>Use the platform for illegal purposes</li>
              <li>Share inappropriate, offensive, or harmful content</li>
              <li>Create multiple accounts with different phone numbers</li>
              <li>Share other members' contact information without consent</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Profile Verification</h2>
            <p>Suvaran Maran Matrimony manually verifies each profile before approval. However, we do not guarantee the authenticity of all user-provided information. Users should independently verify details before making personal decisions.</p>
          </section>

          <section className="legal-section">
            <h2>5. Payment Terms</h2>
            <ul>
              <li>The one-time fee is ₹499 for lifetime membership.</li>
              <li>Payment must be made via UPI to the provided UPI ID.</li>
              <li>Profile activation is subject to admin verification of payment.</li>
              <li>All payments are <strong>non-refundable</strong>. See Refund Policy.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Account Suspension</h2>
            <p>We reserve the right to suspend or terminate accounts that violate these terms without prior notice. In such cases, no refund will be provided.</p>
          </section>

          <section className="legal-section">
            <h2>7. Changes to Terms</h2>
            <p>Suvaran Maran Matrimony reserves the right to update these terms at any time. Updated terms will be posted on this page. Continued use of the platform constitutes acceptance of the updated terms.</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export function Refund() {
  return (
    <div className="static-page">
      <div className="page-header">
        <h1>Refund Policy</h1>
        <p>No Refund Policy</p>
      </div>
      <div className="container static-content">
        <div className="legal-content">
          <div className="refund-alert">
            <h2>⚠️ No Refund Policy</h2>
            <p>All payments made to Suvaran Maran Matrimony are <strong>non-refundable</strong>.</p>
          </div>

          <section className="legal-section">
            <h2>Policy Details</h2>
            <p>Once payment is completed:</p>
            <ul>
              <li>❌ No refunds will be provided under any circumstances</li>
              <li>❌ No partial refunds will be issued</li>
              <li>❌ No cancellation refunds will be granted</li>
              <li>❌ No refunds for rejected profiles due to incorrect payment</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Before Making Payment</h2>
            <p>Users are strongly advised to:</p>
            <ul>
              <li>✅ Review the membership plan carefully</li>
              <li>✅ Ensure your UPI payment is sent to the correct UPI ID: <strong>kubendiransys-1@oksbi</strong></li>
              <li>✅ Save the correct UPI Transaction ID immediately after payment</li>
              <li>✅ Enter the Transaction ID accurately in the payment form</li>
              <li>✅ Contact us before paying if you have any questions</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Payment Verification Issues</h2>
            <p>If your payment cannot be verified due to an incorrect Transaction ID, you will need to re-submit the correct Transaction ID. If you have genuinely paid but cannot be verified, please contact us immediately with proof of payment.</p>
          </section>

          <section className="legal-section">
            <h2>Contact for Payment Issues</h2>
            <p><strong>Suvaran Maran Matrimony</strong><br />
            Phone: +91 9842724724<br />
            Email: support@suvaranmaranmatrimony.msdiscoveriescom<br />
            Working Hours: Monday – Saturday, 9:00 AM – 7:00 PM</p>
          </section>
        </div>
      </div>
    </div>
  );
}
